import { AxiosResponse } from 'axios';
import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { ActionTypes } from '../../constants/ActionTypes';
import { ShowError, ShowSuccess } from '../../helper/Alert';
import {
  IDeleteLetterArgs,
  IInstancePrarams,
  IRestoreLetterArgs,
} from '../../interfaces/Instance';
import { getLocaleMsg } from '../../lngProvider';
import {
  DeleteReferSuccess,
  fetchInstanceSuccess,
  RestoreLetterSuccess,
} from '../actions/Instance';

const getInstance = async (params: IInstancePrarams) => {
  let route: string;
  switch (params.folderCode) {
    case 'DeletedInbox-0':
      route = `instance/LetterDeletedRead?pageIndex=${params.pageIndex}&pageSize=20&searchText=${params.searchText}`;
      break;
    case 'Inbox-0':
      route = `instance/getInboxListByFolder?pageIndex=${params.pageIndex}&pageSize=20&folderId=${params.folderId}&searchText=${params.searchText}`;
      break;
    case 'SentItem-0':
      route = `instance/getSentListByFolder?pageIndex=${params.pageIndex}&pageSize=20&folderId=${params.folderId}&searchText=${params.searchText}`;
      break;
    case 'InboxLetterReferType-0':
      route = `instance/getInboxListByLetterReferType?pageIndex=${params.pageIndex}&pageSize=20&referTypeId=${params.referTypeId}&searchText=${params.searchText}`;
      break;
    case 'SentLetterReferType-0':
      route = `instance/getSentListByLetterReferType?pageIndex=${params.pageIndex}&pageSize=20&referTypeId=${params.referTypeId}&searchText=${params.searchText}`;
      break;
    case 'Follow-0':
      route = `instance/LetterActionFollowInboxRead?pageIndex=${params.pageIndex}&pageSize=20&search=${params.searchText}`;
      break;
    case 'Action-0':
      route = `instance/LetterActionInboxRead?pageIndex=${params.pageIndex}&pageSize=20&search=${params.searchText}`;
      break;
    case 'Search-0':
      route = `searchLetter/simpleSearch?pageIndex=${params.pageIndex}&pageSize=20&searchText=${params.searchText}`;
      break;
    case 'Draft-0':
      route = `instance/LetterDraftRead?folderId=${params.folderId}&currentPage=${params.pageIndex}&pageSize=20&search=${params.searchText}`;
      break;
    case 'Search-1':
      route = `searchLetter/advancedSearch?pageIndex=${params.pageIndex}&pageSize=20&searchText=${params.searchText}`;
      break;
    case 'Process-0':
      route = `bpmInstance/inbox?pageIndex=${params.pageIndex}&pageSize=20&caseId=&engineCode=&wfclassId=&app=&cat=&search=&personalFolderId=`;
      break;
    case 'Process-List':
      route = `bpmInstance/processlist?q=${params.searchText}`;
      break;
    default:
      route = `instance/getInboxListByFolder?pageIndex=${params.pageIndex}&pageSize=20&folderId=undefined&searchText=${params.searchText}`;
      break;
  }

  const http = await FaraGostarDynamicHttp();
  return await http.get(route);
};

const onDeleteRefer = async (params: IDeleteLetterArgs) => {
  const http = await FaraGostarDynamicHttp();
  return await http.post(`instance/DeleteLetters`, {
    letterCodes: params.letterCodes,
    folderCode: params.folderCode,
  });
};

function* fetchInstanceRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedInstance = yield call(getInstance, action.payload);
    yield put(fetchInstanceSuccess(fetchedInstance.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchInstance() {
  yield takeEvery(ActionTypes.GET_LIST_INSTANCE, fetchInstanceRequest);
}

function* deleteDraftRequest(action: any) {
  const messages = getLocaleMsg();
  try {
    yield call(onDeleteRefer, action.payload);
    yield put(DeleteReferSuccess());
    ShowSuccess(messages['messages.operationWasSuccessful'], '');
  } catch (error) {
    return ShowError('', error);
  }
}

export function* deleteRefer() {
  yield takeEvery(ActionTypes.DELETE_REFER, deleteDraftRequest);
}

const onRestoreLetter = async (params: IRestoreLetterArgs) => {
  const http = await FaraGostarDynamicHttp();
  return await http.post(`instance/RestoreLetter`, {
    letterCodes: params.letterCodes,
  });
};

function* restoreLetterRequest(action: any) {
  const messages = getLocaleMsg();
  try {
    yield call(onRestoreLetter, action.payload);
    yield put(RestoreLetterSuccess());
    ShowSuccess(messages['messages.operationWasSuccessful'], '');
  } catch (error) {
    return ShowError('', error);
  }
}

export function* restoreLetter() {
  yield takeEvery(ActionTypes.RESTORE_LETTER, restoreLetterRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchInstance), fork(deleteRefer), fork(restoreLetter)]);
}
